module.exports = "/dist/fonts/mp-round.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/resources/mp-round.svg
// module id = 437
// module chunks = 0